import React from 'react';
import cn from 'classnames';
import {CloseIcon} from 'icons/svg';
import './style.scss';

interface FFToastProps {
    /** The 24px glyph in its tinted square. */
    icon: React.ReactNode;
    title: React.ReactNode;
    children: React.ReactNode;
    /** The line under the text — the toast's one way on. */
    action?: {label: React.ReactNode; onClick: () => void; 'data-testid'?: string};
    onClose: () => void;
    closeLabel: string;
    /** An error's glyph is tinted red, and a screen reader announces it at once. */
    tone?: 'info' | 'error';
    className?: string;
    'data-testid'?: string;
}

/** Figma `Toast` (391:24777): the dark plate over the page — a glyph, a title over its
 *  line of detail, an optional action, and the close in its own corner. It says on
 *  screen until one of the two is pressed; the caller places it. */
export const FFToast = ({icon, title, children, action, onClose, closeLabel, tone = 'info', className, ...rest}: FFToastProps) => (
    <div className={cn('ff-toast', {'ff-toast--error': tone === 'error'}, className)}
         role={tone === 'error' ? 'alert' : 'status'} data-testid={rest['data-testid']}>
        <span className="ff-toast__glyph">{icon}</span>
        <div className="ff-toast__content">
            <p className="ff-toast__title">{title}</p>
            <p className="ff-toast__body">{children}</p>
            {action && (
                <button type="button" className="ff-toast__action" data-testid={action['data-testid']}
                        onClick={action.onClick}>
                    {action.label}
                </button>
            )}
        </div>
        <button type="button" className="ff-toast__close" aria-label={closeLabel} onClick={onClose}
                data-testid={rest['data-testid'] && `${rest['data-testid']}-close`}>
            <CloseIcon/>
        </button>
    </div>
);
